import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import styled from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'

import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { Scroller } from '@ta-interaktiv/react-scroller'
import { Chart } from 'components/Chart'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useWindowSize } from 'usehooks-ts'
import { overlayTexteDE } from './overlayTexte'
import { overlayTexteFr } from './overlayTexte_fr'
import { Stink } from 'components/Stink'

const MainComponent = ({
  tenant,
  colorMode,
  properties,
}: MicroFrontendProps) => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  const { height, width } = useWindowSize()
  const [windowHeight, setWindowHeight] = useState(0)
  const container = useRef<HTMLDivElement>(null)
  const overlayTexte = tenant.lang === 'de' ? overlayTexteDE : overlayTexteFr
  useEffect(() => {
    setWindowHeight(height)
    // eslint-disable-next-line
  }, [width])
  useEffect(() => {
    setWindowHeight(height)
    // eslint-disable-next-line
  }, [])

  const getYPosition = useCallback(
    (e: number) => {
      container.current &&
        scrollTo(container.current, e - windowHeight / 2, 400)
    },
    [windowHeight]
  )

  const Scrolli = (
    <Scroller
      front={overlayTexte.map(({ date, data }, i) => {
        return (
          <FrontElement
            key={'front_' + i}
            id={date}
            distanceTop={i === 0 ? 0 : undefined}
            distanceBottom={300}
          >
            <p>
              <OverlayDate>{data.date}</OverlayDate>
              <OverlayTitle>{data.title}</OverlayTitle>
              {data.text}
            </p>
            {data.links &&
              data.links.map((link, i) => (
                <OverlayLink key={'Link_' + data.date + '_' + i}>
                  <Stink href={link.href + ''}>{link.text}</Stink>
                </OverlayLink>
              ))}
          </FrontElement>
        )
      })}
      back={(index: number, id: string) => {
        return (
          <ChartContainer
            ref={container}
            style={{
              height: windowHeight + 'px',
              maxHeight: windowHeight + 'px',
            }}
          >
            <Chart
              lang={tenant.lang}
              currentDate={id}
              getYPosition={id ? getYPosition : () => {}}
              pointsToMark={overlayTexte.map((m) => m.date)}
            />
          </ChartContainer>
        )
      }}
    />
  )
  return (
    <AppContainer className={globalClasses.join(' ')}>
      {width >= 712 && <TextWidth>{Scrolli}</TextWidth>}
      {width < 712 && <>{Scrolli}</>}
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  .front {
    margin-top: -50%;
  }
`

const ChartContainer = styled.div`
  overflow-y: hidden;
`
const OverlayDate = styled.span`
  font-family: var(--font-sans-serif);
  display: inline-block;
  width: 100%;
  font-size: 12px;
`
const OverlayTitle = styled.span`
  display: inline-block;
  width: 100%;
  font-weight: 700;
  font-size: 22px;
  margin-bottom: 10px;
`
const OverlayLink = styled.span`
  display: inline-block;
  width: 100%;
  margin-top: 10px;
`

const FrontElement = styled.div<{
  distanceBottom?: number
  distanceTop?: number
}>`
  max-width: 550px;
  margin-left: auto;
  margin-right: auto;
  font-family: var(--font-serif);
  z-index: 1002;
  background-color: var(--site-background);
  padding: 20px;
  -webkit-box-shadow: 0px 0px 15px 5px rgba(0, 0, 0, 0.1),
    0px 0px 15px 5px rgba(255, 255, 255, 0.2);
  box-shadow: 0px 0px 15px 5px rgba(0, 0, 0, 0.1),
    0px 0px 15px 0px rgba(255, 255, 255, 0.3);
  line-height: 1.5em;

  padding-bottom: 30px;
  p {
    margin: 0;
  }

  @media screen and (max-width: 711px) {
    margin-left: 0px;
    width: calc(100% - 40px);
  }
`
export default MainComponent

function scrollTo(element: HTMLDivElement, to: number, duration: number) {
  var start = element.scrollTop,
    change = to - start,
    currentTime = 0,
    increment = 20

  var animateScroll = function () {
    currentTime += increment
    var val = easeInOutQuad(currentTime, start, change, duration)
    element.scrollTop = val
    if (currentTime < duration) {
      setTimeout(animateScroll, increment)
    }
  }
  animateScroll()
}

function easeInOutQuad(t: number, b: number, c: number, d: number) {
  if ((t /= d / 2) < 1) return (c / 2) * t * t + b
  return (-c / 2) * (--t * (t - 2) - 1) + b
}
